import { defaultGrid } from "@helpers/datagrid";
import defaultReducer from "./defaultReducer";

export default defaultReducer("COLLECTION_MODAL", {
  open: false,
  title: "Collection Week Banking",
  operator: null,
  siteId: null,
  periodId: null,
  fnLoad: () => {},
  isPerformance: false,
  detailGrid: defaultGrid,
  summaryGrid: defaultGrid,
  categoryGrid: defaultGrid,
  siteFloatGrid: defaultGrid,
  kioskGrid: defaultGrid,
  optionShowViewCommentsButton: false,
  siteText: "",
  weekText: "",
});
